import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressPingHubApiV3NotificationsServiceV3Url(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/notifications-hub-server',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/ping/hub',
        destPath: '',
      },
      {
        srcPath: '/_api/ping/notifications',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/ping/hub',
        destPath: '',
      },
      {
        srcPath: '/_api/ping/notifications',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/notifications/v3/notify',
        destPath: '/v3/notify',
      },
      {
        srcPath: '/notifications/v2/notify',
        destPath: '/v2/notifications/notify',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/ping/notifications/v3/notify',
        destPath: '/v3/notify',
      },
    ],
    _: [
      {
        srcPath: '/ping/notifications/v3/notify',
        destPath: '/v3/notify',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_notifications_notifications-v-3';

/**
 * Sends notifications based on the template and dynamic values provided.
 *
 * > **Note**: An app can call this method up to 100,000 times per month for each site.
 *
 * When you create a [notification template](https://dev.wix.com/docs/rest/business-management/notifications/notifications/creating-a-notification-template), you are provided with a notification template ID. Call the Notify method with this ID as `notificationTemplateID` to trigger notifications based on that template.
 *
 * If the notification template contains placeholders for dynamic values, provide those values as key-value pairs in the `dynamicValues` array. The values you specify are incorporated in the notifications sent out.
 */
export function notify(payload: object): RequestOptionsFactory<any> {
  function __notify({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ping.notifications.v3.notification',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.ping.hub.api.v3.NotificationsServiceV3.Notify',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPingHubApiV3NotificationsServiceV3Url({
        protoPath: '/v3/notify',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __notify;
}
